export function identityFormatter(value: string): string {
  return value;
}
